import { Outlet, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { auth } from './firebase';
import { onAuthStateChanged, signOut } from "firebase/auth";
import './Layout.css';
import Footer from "./Footer";

const Layout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (!navbar) return;

      if (window.scrollY > 5) {
        navbar.classList.add('scroll-shadow');
      } else {
        navbar.classList.remove('scroll-shadow');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    const trimmed = searchTerm.trim();
    if (trimmed.length > 0) {
      navigate(`/search?q=${encodeURIComponent(trimmed)}`);
      setMenuOpen(false);
    }
  };

  return (
    <>
      <nav className="navbar">
        {/* Simple light background with curve */}
        <div className="navbar-light-section"></div>

        <div className="nav-left">
          <div className="logo">
            <img src="\Echelon_logo.png" alt="Echelon Logo" className="logo-img" />
            <div className="logo-text">
              <div className="tagline">Enlightening</div>
              <div className="tagline">Future Minds</div>
            </div>
          </div>

          <form className="search-container" onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </form>
        </div>

        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>

        <ul className={`nav-links ${menuOpen ? 'show' : ''}`}>
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/GetCertified" onClick={() => setMenuOpen(false)}>Get Certified</Link></li>
          <li><Link to="/VolunteerHours" onClick={() => setMenuOpen(false)}>Dashboard</Link></li>
          <li><Link to="/ContactUs" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>

          {!user ? (
            <>
              <li><Link to="/Register" onClick={() => setMenuOpen(false)} className="register-link">Register</Link></li>
              <li><Link to="/Login" onClick={() => setMenuOpen(false)} className="login-link">Login</Link></li>
            </>
          ) : (
            <>
              <li><Link to="/Profile" onClick={() => setMenuOpen(false)}>Profile</Link></li>
              <li>
                <button onClick={handleLogout} className="logout-button">
                  Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </nav>

      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
